import i18n from '../../../utils/i18n';
import Navigation from '../components/navigation/navigation';
import { TextField } from '@mui/material';
import { invoicingInput1 } from '../data/searchFlowText';
import { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../redux/action';
import { withTranslation } from 'react-i18next';
import NewCheckboxInput2 from '../components/searchInputs/newCheckboxInput2';

const Accounts = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	const [inputError, setInputError] = useState(false);

	//force redeploy

	const handleNext = useCallback(
		(inc) => {
			props.handleNext(inc);
		},
		[props]
	);

	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	const dispatch = useDispatch();

	const handleChange = useCallback(
		(event) => {
			const { id } = event.target;

			dispatch((dispatch, getState) => {
				const latestState = getState().company_store.invoicingpref;

				const updatedPref = {
					...latestState,
					[id]: !latestState[id],
				};

				dispatch(
					ACTIONS.addCompanyInfo({
						id: 'invoicingpref',
						data: updatedPref,
						stateObject: 'company_store',
					})
				);
			});
		},
		[dispatch]
	);

	const handleNested = (event, storeId) => {
		dispatch(
			ACTIONS.updateNestedObject({
				stateObject: 'company_store',
				stateObjectID: storeId,
				id: event.target.id,
				data: event.target.value,
			})
		);
	};

	const inputCheck = () => {
		if (
			companyStore.invoicingpref.other &&
			companyStore.invoicingpref.invoicingOtherInput === ''
		) {
			setInputError(true);
			return false;
		} else {
			setInputError(false);
			return true;
		}
	};

	useEffect(() => {
		function handleKeyDown(e) {
			if (e.keyCode === 13) {
				if (
					companyStore.companytype === 'bt' ||
					companyStore.companytype === 'kft' ||
					companyStore.companytype === 'zrt'
				) {
					handleNext();
				} else {
					handleNext(2);
				}
			}
		}
		document.addEventListener('keydown', handleKeyDown);
		return function cleanup() {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [props, handleNext, companyStore.companytype]);

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">
						{i18n.t('searchflow.bankingtext2')}
					</span>{' '}
					<span className="questionTracker">7/8</span>
				</p>
				<NewCheckboxInput2
					dataText={invoicingInput1()}
					checkedValues={companyStore.invoicingpref}
					handleCheck={handleChange}
				/>
			</div>

			{companyStore.invoicingpref.other && (
				<div
					className="SFMarginTop40 SFInputWidth100"
					style={{ margin: '16px auto' }}>
					<TextField
						value={companyStore.invoicingpref.invoicingOtherInput}
						variant="outlined"
						type="text"
						label={i18n.t('industrylabels.other')}
						id="invoicingOtherInput"
						name="invoicingOtherInput"
						onChange={(event) => {
							handleNested(event, 'invoicingpref');
						}}
					/>
				</div>
			)}

			{inputError && (
				<p style={{ color: 'red', fontSize: '12px', fontWeight: 'bold' }}>
					{i18n.t('company.inputerrormsg')}
				</p>
			)}

			<Navigation
				step={7}
				handleBack={() => handleBack()}
				handleNext={() => {
					inputCheck() && handleNext(2);
				}}
				openHelpForm={() => props.openHelpForm()}
			/>
		</div>
	);
};

export default withTranslation()(Accounts);
